export default {
  amount: "Amount",
  createTransaction: "Create Transaction",
  date: "Date",
  id: "ID",
  interac: "Interac",
  invoice: "Invoice",
  messageFrom: "From",
  messageSubject: "Subject",
  transactions: "Transactions",
  noAmountLeft: "No amount left",
  createTransactionFromInteracMessage:
    "Create an invoice transaction using this interac payment. The transaction amount will be the smallest amount between the interac amount left and the invoice amount due.",
  amountLeft: "Amount Left",
};
